import { render } from "./RegistrationIndividualInfo.vue?vue&type=template&id=38870140&scoped=true"
import script from "./RegistrationIndividualInfo.vue?vue&type=script&lang=js"
export * from "./RegistrationIndividualInfo.vue?vue&type=script&lang=js"

import "./RegistrationIndividualInfo.vue?vue&type=style&index=0&id=38870140&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38870140"]])

export default __exports__